import { gql, type TypedDocumentNode } from "@apollo/client";
import { CCMS_SUSPENSION_FRAGMENT, MEMBERSHIP_BAND_FRAGMENT } from "@/fragments";
import type { Band, CcmsSuspension } from "@/types";

export type ActiveYearsBreakdownData = {
  person: {
    id: string;
    activeDaysOfMembership: number | null;
    bands: Band[];
    ccmsSuspensions: CcmsSuspension[];
  };
};

export type ActiveYearsBreakdownVariables = { pgaId: string };

export const ACTIVE_YEARS_BREAKDOWN_QUERY: TypedDocumentNode<ActiveYearsBreakdownData, ActiveYearsBreakdownVariables> =
  gql`
    query ActiveYearsBreakdown($pgaId: ID!) {
      person(pgaId: $pgaId) {
        id
        activeDaysOfMembership
        bands {
          ...MembershipBandFragment
        }
        ccmsSuspensions {
          ...CcmsSuspensionFragment
        }
      }
    }
    ${MEMBERSHIP_BAND_FRAGMENT}
    ${CCMS_SUSPENSION_FRAGMENT}
  `;
